<template>
	<div>
		<div class="d-flex flex-column align-items-center justify-content-center h-full-page">
			<h1 class="text-center mt-3">Download an Authenticator App</h1>
			<p class="text-center text-muted mt-1">Such as Google Authenticator or Microsoft Authenticator</p>

			<div class="d-flex flex-column gap-3 align-items-center justify-content-center">
				<a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&pcampaignid=web_share" target="_blank">
					<img class="img img-fluid" :src="GoogleAuthenticator" alt="Download Google Authenticator" style="width: 8em;">
				</a>
				<a href="https://support.microsoft.com/en-us/account-billing/download-microsoft-authenticator-351498fc-850a-45da-b7b6-27e523b8702a" target="_blank">
					<img class="img img-fluid" :src="MicrosoftAuthenticator" alt="Download Microsoft Authenticator" style="width: 8em;">
				</a>
			</div>

			<div class="d-flex flex-column py-4 gap-1 align-items-center w-100">
				<button class="btn btn-link" @click="moveButtonAction('skip')">skip for now</button>
				<button class="btn btn-dark rounded-pill py-7" :class="width < 992 ? 'w-75' : 'w-50'" @click="moveButtonAction('two-factor-setup')">Continue, I have one</button>
			</div>
		</div>
	</div>
</template>

<script setup>
import GoogleAuthenticator from "@/assets/Google_Authenticator.svg";
import MicrosoftAuthenticator from "@/assets/microsoft-authenticator-1.svg";

const props = defineProps({
	width: [String, Number],
	username: {
		type: String,
		default: null,
		require: false
	}
});

const emits = defineEmits(['navigationButtonClicked']);
const moveButtonAction = (name) => {
	emits('navigationButtonClicked', name);
}
</script>

<style scoped lang="scss">
.w-40 {
	width: 40%;
}
.h-full-page{
	height: calc(100vh - 5px);
}
</style>